import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingGuideComponent } from './fi-onboarding-guide.component';
import { MatCardModule } from '@angular/material/card';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, MatCardModule, FiAppTextSharedModule],
    declarations: [FiOnboardingGuideComponent],
})
export class FiOnboardingGuideModule {}
